import { signal } from '@preact/signals-react';
import { Funcionalidade, Rbac } from '@stt-gestao-pacs/util';

export const usuarioSignal = signal({
    email: '',
    nome: '',
    login: '',
    permissoesRBAC: [],
    perfisRBAC: [],
    submodulos: [],
    isAuthorized: false,
    rbac: new Rbac([]),
    autenticado: false,
});

export const alterarUsuario = ({ email, nome, login, permissoesRBAC = [], perfisRBAC = [] }) => {
    const rbac = new Rbac(perfisRBAC);

    const isAuthorized = rbac.montarAcesso(Funcionalidade.MODULO).temPermissao;

    usuarioSignal.value = {
        ...usuarioSignal.value,
        email,
        nome,
        login,
        permissoesRBAC,
        perfisRBAC,
        isAuthorized,
        rbac,
        autenticado: true,
    };
};

export const autenticar = () => {
    usuarioSignal.value = {
        ...usuarioSignal.value,
        autenticado: true,
    };
};